import React, { useMemo } from 'react';
import { Box, FlexListHeader, Inscription, ListItemBase, Preloader } from '@common-fe/common-fe';
import styled from 'styled-components';

import { NOT_AVAILABLE_LABEL } from '@/modules/deductibles/SpendTracker/queries/useDeductibles.query.ts';
import currentTheme from '@/styles/theme';

interface Tier {
  id: string;
  name: string;
  validFrom?: string;
  validTo?: string;
}

const Wrapper = styled(Box)`
  &:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spacings.spacing8};
  }
`;

const TierPeriodsTable: React.FC<{
  formattedTiers: Tier[];
  isLoading?: boolean;
}> = ({ formattedTiers, isLoading }) => {
  const headers: ListItemBase[] = useMemo(() => {
    const currentHeaders = [
      {
        key: 'Tier',
        title: 'Tier',
        flex: 2,
      },
      {
        key: 'period',
        title: 'Period',
        flex: 3,
      },
    ];
    return currentHeaders;
  }, []);
  return (
    <Box
      data-testid="tier-periods-wrapper"
      background="module"
      pad="xs"
      round="container1Round"
      margin={{ vertical: 'xs' }}
    >
      <FlexListHeader items={headers} thinMode />
      {isLoading ? (
        <Box margin={{ vertical: 'xs' }}>
          <Preloader testId="loading-spinner" size={18} />
        </Box>
      ) : (
        <>
          {formattedTiers?.map((item, index) => (
            <Wrapper
              key={item?.id}
              height="42px"
              elevation="default"
              background="canvas"
              round={currentTheme.rounds.button1Round}
              margin={{ top: index === 0 ? 'xs' : '0px' }}
              pad={{ vertical: 's', horizontal: 'l' }}
              direction="row"
              align="center"
            >
              <Box height="24px" direction="row" align="center" width="40%">
                <Inscription color="textBody" size="12px" lineHeight="18px" weight={500}>
                  {item?.name}
                </Inscription>
              </Box>
              <Box height="24px" direction="row" align="center" width="60%">
                <Inscription color="textBody" size="12px" lineHeight="18px" weight={500}>
                  {item?.validFrom}
                </Inscription>
                {item?.validFrom && <>&nbsp;-&nbsp;</>}
                <Inscription
                  color={item.validTo === NOT_AVAILABLE_LABEL ? 'textDisabled' : 'textBody'}
                  size="12px"
                  lineHeight="18px"
                  weight={500}
                >
                  {item?.validTo}
                </Inscription>
              </Box>
            </Wrapper>
          ))}
        </>
      )}
    </Box>
  );
};

export default TierPeriodsTable;
